import { describeFields, FieldWidget } from '../common/fields';
import { StudentActivityLogSchema } from './schemas';

export const STUDENT_ACTIVITY_LOG_FIELDS = describeFields(StudentActivityLogSchema, {
  studentId: {},
  subject: { widget: FieldWidget.Text },
  classCode: {},
  teacherId: {},
  activityType: { widget: FieldWidget.Text },
  class: {},
  classSize: {},
  reason: {},
  reasonCategory: { widget: FieldWidget.Text },
  createdBy: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  courseState: { widget: FieldWidget.Text },
  studentState: { widget: FieldWidget.Text },
  attendedLessonsCount: {},
  totalLessonsCount: {},
  recentAttendedTeacherIds: {},
  recentAttendedLessons: {},
});
